import React from "react";
import AccountSettingSidebar from "../components/AccountSettingSidebar";

import SurveyListHeader from "../../../../component/layout/MainHeader";
import Svg from "../../../../component/Svg";
import Input from "../../../../core/Inputs/DefaultInput";

import { Formik } from "formik";

import CreatableSelect from "react-select/creatable";
import SurveyListSidebar from "../../../../component/layout/MainSidebar";
import { Link, useNavigate } from "react-router-dom";
import { createTeamSchema } from "../../../../schema/team";
import { addTeam } from "../../../../store/actions/teamAction";
import { useDispatch } from "react-redux";
import NestedMenuToggle from "../NestedMenuToggle";

export default function Create() {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/roi"
                        className="home-item"
                        title="Dashboard"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    {/* <li className="breadcrumb-item">
                      <Link to="/admin/settings/user-permissions">
                        User & Teams
                      </Link>
                    </li> */}
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/teams/list">Teams</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Create team</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Create team</h1>
                    </div>
                  </div>
                </div>
                <div className="pagesRow varPg">
                  <div className="role-wrapper flex-grow-1">
                    <Formik
                      initialValues={{
                        team_name: "",
                        is_active: "1",
                      }}
                      enableReinitialize
                      validationSchema={createTeamSchema}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        //console.log("values", values);
                        let dataToSend = {
                          team_name: values.team_name,
                          is_active: values.is_active,
                        };
                        dispatch(addTeam(dataToSend));
                        resetForm();
                        navigate("/admin/settings/teams/list");
                        setSubmitting(false);
                      }}
                    >
                      {({
                        values,
                        errors,
                        handleChange,
                        handleSubmit,
                        resetForm,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="create-team-form">
                            <div className="row gx-12px">
                              <div className="col-lg-6 position-relative">
                                <div className="form-group mb-12px">
                                  <label>Team name</label>
                                  <Input
                                    type="text"
                                    view="outlined"
                                    dense={false}
                                    name="team_name"
                                    color="default"
                                    label=""
                                    placeholder="Team name"
                                    clearButton={true}
                                    success={false}
                                    error={false}
                                    fill={true}
                                    errorHelperText={null}
                                    className={"formsinput"}
                                    defaultValue={values.team_name}
                                    onChange={handleChange}
                                    maxLength={100}
                                  />
                                </div>
                                {errors.team_name && (
                                  <div className="validation-msg">
                                    {errors.team_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="button-wrap">
                              <button type="submit" className="btn btn-primary">
                                Save
                              </button>
                              {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                              {/* <button type="button" className="btn btn-primary">Save</button> */}
                              
                            </div>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  );
}
